import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import SettingsLayout from './SettingsLayout';
import AptitudeBuilderSection from './AptitudeBuilderSection';

/**
 * /hirewithus/settings/aptitude-builder — the company Aptitude Builder,
 * rendered inside the unified Settings shell. Reached from the "Question
 * templates" hub, so it carries a back link to it and keeps that tab active.
 */
const AptitudeBuilderPage = () => {
  const navigate = useNavigate();
  return (
    <SettingsLayout
      activeKey="templates"
      title="Settings"
      description="Manage your company profile, interview panel, recruiter access, and interview question templates."
    >
      <button
        type="button"
        onClick={() => navigate('/hirewithus/settings/templates')}
        className="inline-flex items-center gap-1 text-sm text-muted-foreground hover:text-foreground mb-1 -mt-2"
      >
        <ArrowLeft className="w-4 h-4" /> Question templates
      </button>
      <AptitudeBuilderSection />
    </SettingsLayout>
  );
};

export default AptitudeBuilderPage;
